import {
  always,
  applySpec,
  compose,
  ifElse,
  not,
  includes,
  toLower,
} from 'ramda';

import { deltaConfig } from 'app/features/deltaConfig/selectors';
import {
  isEligibleForFreeTrial,
  isUserAuthenticated,
  isUserPremium,
  userAccessType,
  userEmail,
  userId,
  username,
} from 'app/features/user/selectors';
import { RUM } from 'packages/rum';

const setDDUser = compose(
  user => RUM.getInstance()?.setUser(user),
  ifElse(
    isUserAuthenticated,
    applySpec({
      id: userId,
      name: username,
      email: userEmail,
      accessType: userAccessType,
      isPremium: compose(String, isUserPremium),
      isEligibleForFreeTrial: compose(String, isEligibleForFreeTrial),
    }),
    always({}),
  ),
);

const setDDContext = compose(
  configDelta => RUM.getInstance()?.setGlobalContext({ configDelta }),
  deltaConfig,
);

const isNotPrerenderUserAgent = compose(
  not,
  includes('prerender'),
  toLower,
  () => window.navigator.userAgent,
);

export { setDDUser, setDDContext, isNotPrerenderUserAgent };
